import axios from "axios";
import authenticateService from "@services/authentication.service";
import { getToken, setRequestConfig } from "./utils";

const instance = axios.create({
  timeout: 5 * 60 * 1000,
  headers: {
    "Accept-Language": "fa",
  },
});

class Request {
  constructor(baseUrl, headers) {
    this.self = {
      baseUrl,
      headers,
    };
  }

  post = (endpoint, data, config = {}) => {
    const url = `${this.self.baseUrl}${endpoint}`;
    return instance({
      url,
      data,
      method: "POST",
      headers: this.self.headers,
      ...config,
    });
  };

  get = (endpoint, params, config = {}) => {
    const url = `${this.self.baseUrl}${endpoint}`;
    return instance({
      url,
      params,
      method: "GET",
      headers: this.self.headers,
      ...config,
    });
  };

  request = (endpoint, config = {}) => {
    const url = `${this.self.baseUrl}${endpoint}`;
    return instance({
      url,
      ...config,
    });
  };

  put = (endpoint, data, config) => {
    const url = `${this.self.baseUrl}${endpoint}`;
    return instance({
      url,
      data,
      method: "PUT",
      headers: this.self.headers,
      ...config,
    });
  };

  patch = (endpoint, data, config = {}) => {
    const url = `${this.self.baseUrl}${endpoint}`;
    return instance({
      url,
      data,
      method: "PATCH",
      headers: this.self.headers,
      ...config,
    });
  };

  delete = (endpoint, data, config = {}) => {
    const url = `${this.self.baseUrl}${endpoint}`;
    return instance({
      url,
      data,
      method: "DELETE",
      headers: this.self.headers,
      ...config,
    });
  };
}

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const tokens = getToken();
    const { url } = config;

    const newConfig = config;

    if (
      !url?.startsWith("/v1/user/login/") &&
      !url?.startsWith(
        `${process.env.REACT_APP_BASE_API_URL}/v1/user/login/`
      ) &&
      !url?.startsWith("/v1/user/login/")
    ) {
      if (!tokens) window.location.href = "/";

      newConfig.headers.Authorization = `Bearer ${tokens}`;
      setRequestConfig({
        headers: { Authorization: `Bearer ${tokens}` },
      });
    }

    return newConfig;
    // Do something before request is sent
  },
  (error) => {
    // Do something with request error
    Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) =>
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response,
  (error) => {
    // const newConfig = error.config;
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (!error.response) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        reject({
          errors: null,
          message: "Error to connection server",
        });
      });
    }

    if (error.response && error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        if (error.response.data && error.response.data.message) {
          // eslint-disable-next-line
          reject({
            errors: error.response.data.message,
            message: error.response.statusText,
          });
        } else {
          // eslint-disable-next-line
          reject({
            errors: null,
            message: error.response.statusText,
          });
        }
      });
    }

    authenticateService.logout();
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
);

export default Request;
